import PropTypes from 'prop-types';
import React from 'react';
import _ from 'underscore';
import { titleize, unescapeHTML } from 'underscore.string';
import SessionStore from 'stores/SessionStore';
import UserStore from 'stores/UserStore';
import CargomaticInput from 'components/v2/input';
import CargomaticSelect from 'components/v2/select';
import { stateCodes } from 'components/modules/user/user-form-utils';
import MarketsStore from 'stores/MarketsStore';
import 'utils/selectize';
import TagEditor from 'components/ui/TagEditor';
import SignedUrl from 'utils/SignedUrlUtils';
import Constants from 'constants/AdminConstants';
import Multiselect from 'components/v2/multi-select';
import { getRegionLinesOfBusiness } from 'config/lines-of-business';
import { SERVICE_TYPES } from 'config/service-types';
import { isProd } from 'helpers/helper_functions';
import UserActionCreators from 'actions/UserActionCreators';
import { withTranslation } from 'react-i18next';
import { unescapeSpecialChars } from 'src/main/js/helpers/helper_functions';
import PhoneField from 'components/v2/forms/PhoneField';
import { AuthorizationWrapper } from 'components/wrappers/AuthorizationWrapper';
import { REGIONS } from 'constants/Regions';
import { wholeNumberRegex } from '../../../../utils/validation-regex';
import { CARRIER_SUBSIDIARY_OPTIONS, ASSET_CARRIERS, NON_ASSET_CARRIERS, } from 'constants/subsidiary';
import { DRIVER_CATEGORIZATION_OPTIONS } from 'constants/DriverCategorization';
// TODO: What are required for carrier?
const REQUIRED_ATTRIBUTES = [
    'first_name',
    'last_name',
    'phone',
    'email',
    'street',
    'city',
    'state',
    'zipcode',
];
const MAX_TERM = 120;
const PAYMENT_METHODS = [
    {
        name: 'Automated',
        value: 'automated',
        localizationSlug: 'AUTOMATED',
    },
    {
        name: 'Manual',
        value: 'manual',
        localizationSlug: 'MANUAL',
    },
];
const getRequiredAsterisk = (field) => {
    return REQUIRED_ATTRIBUTES.includes(field) ? '*' : '';
};
const renderAuthDocs = async (docs) => {
    const { t } = this.props;
    if (!docs || !docs.length)
        return React.createElement("span", null, t('NO_AUTHORIZATION_DOCUMENT'));
    try {
        const promises = docs
            .filter((d) => d.uri && d.type)
            .map((d) => {
            return SignedUrl.getSignedUrl(d.uri_type, d.uri);
        });
        const urls = await Promise.all(promises);
        const list = docs.map((d, i) => (React.createElement("li", { key: d._id },
            React.createElement("a", { href: urls[i], rel: "noopener noreferrer", target: "_blank" }, d.label))));
        return React.createElement("ul", null, list);
    }
    catch (e) {
        return React.createElement("ul", null, e.message);
    }
};
class CarrierForm extends React.Component {
    constructor(props) {
        super(props);
        this.handleAdminUsersChange = () => {
            const users = UserStore.getAdminUsers() || [];
            const getUsers = () => {
                return users.map((user) => {
                    return {
                        _id: user._id,
                        email: user.email,
                    };
                });
            };
            this.setState({ adminUsers: _.sortBy(getUsers(), 'email') });
        };
        this.onSave = () => {
            const { changed } = this.state;
            const { carrier } = this.state;
            if (this.props.category === 'address') {
                if (!this.areRequiredFieldsPresent(carrier.address, [
                    'street',
                    'street2',
                    'city',
                    'state',
                    'zipcode',
                ])) {
                    return;
                }
            }
            // @TODO maybe refactor this...
            _.map(changed, (_changeItem, key) => {
                if (typeof carrier[key] === 'string')
                    carrier[key] = carrier[key].trim();
                if (key === 'address') {
                    const address = carrier.address;
                    _.map(carrier.address, (_item, addressKey) => {
                        address[addressKey] = address[addressKey].trim();
                    });
                    carrier.address = address;
                }
                if (key === 'markets') {
                    carrier.markets = carrier.markets.map((m) => m._id);
                }
            });
            const updates = _.pick(carrier, Object.keys(changed));
            updates._id = carrier._id;
            this.props.onSave(updates);
        };
        this.isRequiredField = () => `${this.props.t('IS_REQUIRED_FIELD')}`;
        this.areRequiredFieldsPresent = (parent, fields) => {
            const { t } = this.props;
            const errors = this.state.errors;
            fields.forEach((field) => {
                errors[field] =
                    !parent[field] && REQUIRED_ATTRIBUTES.includes(field)
                        ? {
                            message: `${t(field.toUpperCase())} ${this.isRequiredField()}`,
                        }
                        : {};
            });
            this.setState((prevState) => {
                return Object.assign(Object.assign({}, prevState), { errors });
            });
            const allPresent = _.every(fields, (f) => _.isEmpty(errors[f]));
            return allPresent;
        };
        this.handleAddressFieldChange = (field, value) => {
            const { t } = this.props;
            const { carrier, changed, errors } = this.state;
            const address = carrier.address;
            address[field] = value;
            carrier.address = address;
            changed.address = true;
            errors[field] =
                !value && REQUIRED_ATTRIBUTES.includes(field)
                    ? {
                        message: `${t(field.toUpperCase())} ${this.isRequiredField()}`,
                    }
                    : {};
            this.setState({ carrier, changed, errors });
        };
        this.handleFieldChange = (field, value) => {
            const { t } = this.props;
            const { carrier, changed, errors } = this.state;
            carrier[field] = value;
            changed[field] = true;
            errors[field] =
                !value && REQUIRED_ATTRIBUTES.includes(field)
                    ? {
                        message: `${t(field.toUpperCase())} ${this.isRequiredField()}`,
                    }
                    : {};
            if (field === 'subsidiary' &&
                (NON_ASSET_CARRIERS.includes(value) || value === null)) {
                if (value === null) {
                    carrier.driver_categorization = null;
                    changed.driver_categorization = true;
                    errors.driver_categorization = {};
                }
                else {
                    errors.driver_categorization = {};
                }
            }
            if (changed['subsidiary'] === true &&
                !(carrier === null || carrier === void 0 ? void 0 : carrier.driver_categorization) &&
                ASSET_CARRIERS.includes(carrier === null || carrier === void 0 ? void 0 : carrier.subsidiary)) {
                errors['driver_categorization'] = {
                    message: 'Driver categorization required',
                };
            }
            if (field === 'driver_categorization' &&
                value === null &&
                ASSET_CARRIERS.includes(carrier === null || carrier === void 0 ? void 0 : carrier.subsidiary)) {
                errors['driver_categorization'] = {
                    message: 'Driver categorization required',
                };
            }
            if (field === 'drayage_terms' || field === 'shorthaul_terms') {
                if (value && !wholeNumberRegex.test(Number(value))) {
                    errors[field] = { message: 'It should not have decimal' };
                }
                if (Number(value) > MAX_TERM || Number(value) < 0) {
                    errors[field] = { message: 'It should be between 0 and 120' };
                }
                if (isProd()) {
                    if (Number(value) > MAX_TERM || Number(value) < 1) {
                        errors[field] = { message: 'It should be between 1 and 120' };
                    }
                }
            }
            this.setState({ carrier, changed, errors });
        };
        this.handleMarketsSelect = (markets) => {
            const { changed, carrier } = this.state;
            carrier.markets = markets;
            changed.markets = true;
            this.setState({ carrier, changed });
        };
        this.handleLinesOfBusinessSelect = (linesOfBusiness) => {
            const carrier = Object.assign(Object.assign({}, this.state.carrier), { linesOfBusiness: linesOfBusiness.map((lob) => lob.slug) });
            const changed = Object.assign(Object.assign({}, this.state.changed), { linesOfBusiness: true });
            this.setState((prevState) => {
                return Object.assign(Object.assign({}, prevState), { carrier, changed });
            });
        };
        this.handleServiceTypeSelect = (serviceTypes) => {
            const carrier = Object.assign(Object.assign({}, this.state.carrier), { service_type: serviceTypes.map((st) => st.slug) });
            const changed = Object.assign(Object.assign({}, this.state.changed), { service_type: true });
            this.setState((prevState) => {
                return Object.assign(Object.assign({}, prevState), { carrier, changed });
            });
        };
        this.state = {
            carrier: props.details,
            errors: {
                first_name: {},
                last_name: {},
                name: {},
                dot_number: {},
                phone: {},
                phone_extension: {},
                email: {},
                address: {},
                bank_verified: {},
                authorized: {},
                tsa: {},
                residential: {},
                test: {},
                hazmat_certified: {},
                tsa_certified: {},
                is_owner_operator: {},
                is_dray: {},
                beta_tester: {},
                driver_categorization: {},
                lease_on: {},
            },
            changed: {},
            pictureUrl: '',
            canAuthorize: SessionStore.hasComplianceRole(),
            adminUsers: [],
        };
        this.state.authDocs = React.createElement("ul", null);
    }
    async componentDidMount() {
        const { carrier, changed } = this.state;
        const { t } = this.props;
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const me = this;
        UserStore.addChangeListener(this.handleAdminUsersChange);
        UserActionCreators.getAdminUsers({ active: true });
        $(this.refs.tags).selectize({
            persist: false,
            create: true,
            onItemAdd(value) {
                if (carrier.tags.indexOf(value) === -1) {
                    carrier.tags = carrier.tags.concat([value]);
                    changed.tags = true;
                    me.setState({ carrier, changed });
                }
            },
            onItemRemove(value) {
                const tags = carrier.tags.slice(0);
                const index = tags.indexOf(value);
                if (index !== -1) {
                    tags.splice(index, 1);
                    carrier.tags = tags;
                    changed.tags = true;
                    me.setState({ carrier, changed });
                }
            },
        });
        try {
            let pictureUrl = '';
            if (this.state.company_logo) {
                pictureUrl = await SignedUrl.getSignedUrl('userdata', this.state.company_logo);
            }
            const authDocs = await renderAuthDocs(this.props.details.authorization_documents);
            this.setState({ pictureUrl, authDocs });
        }
        catch (e) {
            console.error(`${t('CARRIER_FORM_SIGNED_URL_ERROR')}: `, e);
        }
    }
    componentWillUnmount() {
        UserStore.removeChangeListener(this.handleAdminUsersChange);
    }
    errorsExist() {
        const { errors } = this.state;
        let errorsExist = false;
        _.map(errors, (value, key) => {
            if (!_.isEmpty(errors[key]))
                errorsExist = true;
        });
        return errorsExist;
    }
    carrierHasMarket(marketId) {
        const { carrier: { markets }, } = this.state;
        return !!_.findWhere(markets, { _id: marketId });
    }
    renderMarkets() {
        const { t } = this.props;
        const markets = _.map(MarketsStore.getMarkets(), (market) => {
            return {
                _id: market._id,
                name: t(market === null || market === void 0 ? void 0 : market.localizationSlug),
                slug: market.name,
                selected: this.carrierHasMarket(market._id),
            };
        });
        return (React.createElement("div", { className: "sm:col-span-3" },
            React.createElement("label", { className: "mb-1 form-label" }, titleize(t('MARKET', { count: 2 }))),
            React.createElement(Multiselect, { label: titleize(t('MARKET', { count: 2 })), items: markets, onSelect: this.handleMarketsSelect })));
    }
    renderLinesOfBusiness() {
        const lobs = getRegionLinesOfBusiness();
        const { t } = this.props;
        const linesOfBusiness = lobs.map((lob) => {
            return Object.assign(Object.assign({}, lob), { selected: this.state.carrier.linesOfBusiness.includes(lob.slug) });
        });
        return (React.createElement("div", { className: "sm:col-span-3" },
            React.createElement("label", { className: "mb-1 form-label" }, t('LINES_OF_BUSINESS')),
            React.createElement(Multiselect, { label: t('LINES_OF_BUSINESS'), items: linesOfBusiness, onSelect: this.handleLinesOfBusinessSelect })));
    }
    renderServiceType() {
        const { t } = this.props;
        const serviceTypes = SERVICE_TYPES.map((st) => {
            return Object.assign(Object.assign({}, st), { selected: this.state.carrier.service_type.includes(st.slug) });
        });
        return (React.createElement("div", { className: "sm:col-span-3" },
            React.createElement("label", { className: "mb-1 form-label" }, t('SERVICE_TYPE')),
            React.createElement(Multiselect, { label: t('SERVICE_TYPE'), items: serviceTypes, onSelect: this.handleServiceTypeSelect })));
    }
    render() {
        const { carrier: { name, first_name, last_name, dot_number, primary_scac_code, phone, phone_extension, email, drayage_terms, drayage_payment_method, shorthaul_terms, shorthaul_payment_method, tags, has_flatbed_trucks, hazmat_certified, tsa_certified, is_owner_operator, is_dray, authorized, test, enterprise, preferred_carrier, address: { street, street2, city, state, zipcode }, group_like_payout_items, crm_mapping_id, bank_verified, subsidiary, driver_categorization, lease_on, }, carrier, canAuthorize, } = this.state;
        const { errors } = this.state;
        const { category, t } = this.props;
        return (React.createElement("div", null,
            category === 'account' && (React.createElement("div", null,
                React.createElement("h4", { className: "text-grey-darker" }, t('ACCOUNT_INFORMATION')),
                React.createElement("div", { className: "grid sm:grid-cols-6 sm:gap-x-4 gap-y-6" },
                    React.createElement(CargomaticInput, { className: "sm:col-span-3", error: errors.name, label: ` ${titleize(t('NAME'))} ${getRequiredAsterisk('name')}`, info: `${titleize(t('CARRIER_NAME'))}`, onChange: (value) => this.handleFieldChange('name', value), value: unescapeSpecialChars(name), maxLength: 75 }),
                    React.createElement(CargomaticInput, { className: "sm:col-span-3", error: errors.dot_number, label: ` ${titleize(t('DOT_NUMBER'))} ${getRequiredAsterisk('')}`, info: `${titleize(t('CARRIER_DOT_NUMBER'))}`, onChange: (value) => {
                            this.handleFieldChange('dot_number', value);
                        }, value: dot_number }),
                    React.createElement("div", { className: "sm:col-span-6" },
                        React.createElement("div", { className: "grid sm:grid-cols-2 sm:gap-x-4" },
                            React.createElement(CargomaticInput, { className: "sm:col-span-1", error: errors.primary_scac_code, label: t('SCAC_CODE'), onChange: (value) => this.handleFieldChange('primary_scac_code', value), value: unescapeHTML(primary_scac_code) }))),
                    React.createElement(CargomaticInput, { className: "sm:col-span-3", error: errors.first_name, label: `${titleize(t('FIRST_NAME'))} ${getRequiredAsterisk('first_name')}`, info: t('CARRIER_FIRST_NAME'), onChange: (value) => {
                            this.handleFieldChange('first_name', value);
                        }, value: unescapeSpecialChars(first_name) }),
                    React.createElement(CargomaticInput, { className: "sm:col-span-3", error: errors.last_name, label: ` ${titleize(t('LAST_NAME'))} ${getRequiredAsterisk('last_name')}`, info: t('CARRIER_LAST_NAME'), onChange: (value) => this.handleFieldChange('last_name', value), value: unescapeSpecialChars(last_name) }),
                    React.createElement("div", { className: "sm:col-span-3" },
                        React.createElement("label", { className: "form-label mb-1" }, `${titleize(t('PHONE'))} ${getRequiredAsterisk('phone')}`),
                        React.createElement(PhoneField, { id: "phone", onChange: (value) => this.handleFieldChange('phone', value), value: phone })),
                    React.createElement(CargomaticInput, { className: "sm:col-span-3", error: errors.phone_extension, label: ` ${titleize(t('EXT'))} ${getRequiredAsterisk('')}`, info: `${titleize(t('PHONE_NUMBER_EXTENSION_INFO'))}`, onChange: (value) => {
                            this.handleFieldChange('phone_extension', value);
                        }, value: phone_extension }),
                    React.createElement(CargomaticInput, { className: "sm:col-span-3", error: errors.email, label: `${titleize(t('EMAIL_ADDRESS'))}  ${getRequiredAsterisk('email')}`, info: t('CARRIER_EMAIL_ADDRESS'), onChange: (value) => this.handleFieldChange('email', value), value: email, maxLength: 254 }),
                    this.renderMarkets(),
                    this.renderLinesOfBusiness(),
                    React.createElement(CargomaticInput, { className: "sm:col-span-3", error: errors.crm_mapping_id, label: t('CRM_MAPPING_ID'), info: t('CRM_MAPPING_ID'), onChange: (value) => {
                            this.handleFieldChange('crm_mapping_id', value);
                        }, value: unescapeSpecialChars(crm_mapping_id) }),
                    this.renderServiceType(),
                    React.createElement("div", { className: "sm:col-span-6" },
                        React.createElement("label", null, t('PAYMENT_TERMS')),
                        React.createElement("div", { className: "grid sm:grid-cols-2 sm:gap-x-4" },
                            React.createElement(CargomaticInput, { type: "number", label: t('DRAYAGE'), error: errors.drayage_terms, onChange: (value) => this.handleFieldChange('drayage_terms', value), value: drayage_terms, min: 0, step: 1 }),
                            React.createElement(CargomaticInput, { type: "number", label: t('SHORTHAUL'), error: errors.shorthaul_terms, onChange: (value) => this.handleFieldChange('shorthaul_terms', value), value: shorthaul_terms, min: 0, step: 1 }))),
                    React.createElement("div", { className: "sm:col-span-6" },
                        React.createElement("label", null, t('PAYMENT_METHOD')),
                        React.createElement("div", { className: "grid sm:grid-cols-2 sm:gap-x-4" },
                            React.createElement(CargomaticSelect, { label: t('DRAYAGE'), textKey: "localizationSlug", valueKey: "value", value: drayage_payment_method, items: PAYMENT_METHODS, onSelect: (item) => this.handleFieldChange('drayage_payment_method', item.value) }),
                            React.createElement(CargomaticSelect, { label: t('SHORTHAUL'), textKey: "localizationSlug", valueKey: "value", value: shorthaul_payment_method, items: PAYMENT_METHODS, onSelect: (item) => this.handleFieldChange('shorthaul_payment_method', item.value) }))),
                    React.createElement("div", { className: "col-span-6" },
                        React.createElement("label", { className: "mb-1 form-label" }, t('TAGS')),
                        React.createElement(TagEditor, { object: carrier, tags: tags, suggestions: Constants.carrierTagSuggestions, handleChange: (_user, selectedTags) => {
                                this.handleFieldChange('tags', selectedTags);
                            }, hideLabel: false }))))),
            category === 'address' && (React.createElement("div", null,
                React.createElement("h4", { className: "mt-0 mb-4 text-grey-darker" }, t('ADDRESS_INFO')),
                React.createElement("div", { className: "grid sm:grid-cols-3 sm:gap-x-4 gap-y-6" },
                    React.createElement(CargomaticInput, { className: "sm:col-span-3", error: errors.street, label: `${titleize(t('STREET'))} ${getRequiredAsterisk('street')}`, info: t('CARRIER_STREET_TIP'), onChange: (value) => {
                            this.handleAddressFieldChange('street', value);
                        }, value: street }),
                    React.createElement(CargomaticInput, { className: "sm:col-span-3", error: errors.street2, label: `${titleize(t('STREET_2'))}  ${getRequiredAsterisk('street2')}`, info: t('CARRIER_STREET_2_TIP'), onChange: (value) => {
                            this.handleAddressFieldChange('street2', value);
                        }, value: street2 }),
                    React.createElement(CargomaticInput, { error: errors.city, label: `${titleize(t('CITY'))} ${getRequiredAsterisk('city')}`, info: t('CARRIER_CITY_TIP'), onChange: (value) => {
                            this.handleAddressFieldChange('city', value);
                        }, value: city }),
                    React.createElement(CargomaticSelect, { error: errors.state, selected: state, items: stateCodes, info: t('CARRIER_STATE_TIP'), label: ` ${titleize(t('STATE'))} ${getRequiredAsterisk('state')}`, textKey: "name", valueKey: "abbreviation", onSelect: (item) => {
                            this.handleAddressFieldChange('state', item.abbreviation);
                        } }),
                    React.createElement(CargomaticInput, { error: errors.zipcode, label: `${titleize(t('ZIP_CODE'))} ${getRequiredAsterisk('zipcode')}`, info: t('CARRIER_POSTAL_CODE_TIP'), onChange: (value) => {
                            this.handleAddressFieldChange('zipcode', value);
                        }, value: zipcode })))),
            category === 'capabilities' && (React.createElement("div", null,
                React.createElement("h3", { className: "mt-0 mb-4" }, t('CAPABILITIES')),
                React.createElement("div", { className: "grid sm:grid-cols-2 sm:gap-x-4" },
                    React.createElement(AuthorizationWrapper, { excludedRegions: [REGIONS.US] },
                        React.createElement(CargomaticInput, { id: "bank_verified", type: "checkbox", error: errors.bank_verified, label: `${titleize(t('BANK_VERIFIED'))} ${getRequiredAsterisk('bank_verified')}`, info: t('BANK_VERIFIED'), onChange: (value) => {
                                this.handleFieldChange('bank_verified', value);
                            }, value: bank_verified })),
                    canAuthorize && (React.createElement(CargomaticInput, { id: "authorized", type: "checkbox", error: errors.authorized, label: `${titleize(t('AUTHORIZED'))} ${getRequiredAsterisk('authorized')}`, info: t('AUTHORIZATION_STATUS'), onChange: (value) => {
                            this.handleFieldChange('authorized', value);
                        }, value: authorized })),
                    React.createElement(CargomaticInput, { id: "enterprise", type: "checkbox", error: errors.enterprise, label: `${t('ENTERPRISE')} ${getRequiredAsterisk('enterprise')}`, info: t('ENTERPRISE_CARRIER'), onChange: (value) => {
                            this.handleFieldChange('enterprise', value);
                        }, value: enterprise }),
                    React.createElement(CargomaticInput, { id: "preferred_carrier", type: "checkbox", error: errors.preferred_carrier, label: `${t('PREFERRED_CARRIER')} ${getRequiredAsterisk('preferred_carrier')}`, info: t('PREFERRED_CARRIER'), onChange: (value) => {
                            this.handleFieldChange('preferred_carrier', value);
                        }, value: preferred_carrier }),
                    React.createElement(CargomaticInput, { id: "has_flatbed_trucks", type: "checkbox", error: errors.has_flatbed_trucks, label: `${t('HAS_FLATBED_TRUCKS')} ${getRequiredAsterisk('has_flatbed_trucks')}`, info: t('FLATBED_TRUCK'), onChange: (value) => {
                            this.handleFieldChange('has_flatbed_trucks', value);
                        }, value: has_flatbed_trucks }),
                    React.createElement(CargomaticInput, { id: "hazmat_certified", type: "checkbox", error: errors.hazmat_certified, label: `${t('HAZMAT_CERTIFIED')} ${getRequiredAsterisk('hazmat_certified')}`, info: t('HAZMAT_CERTIFIED'), onChange: (value) => {
                            this.handleFieldChange('hazmat_certified', value);
                        }, value: hazmat_certified }),
                    React.createElement(CargomaticInput, { id: "tsa_certified", type: "checkbox", error: errors.tsa_certified, label: `${t('TSA_CERTIFIED')} ${getRequiredAsterisk('tsa_certified')}`, info: t('TSA_CERTIFIED'), onChange: (value) => {
                            this.handleFieldChange('tsa_certified', value);
                        }, value: tsa_certified }),
                    React.createElement(CargomaticInput, { id: "is_owner_operator", type: "checkbox", error: errors.is_owner_operator, label: `${t('OWNER_OPERATOR')} ${getRequiredAsterisk('is_owner_operator')}`, info: t('OWNER_OPERATOR'), onChange: (value) => {
                            this.handleFieldChange('is_owner_operator', value);
                        }, value: is_owner_operator }),
                    React.createElement(CargomaticInput, { id: "is_dray", type: "checkbox", error: errors.is_dray, label: `${t('DRAY_OPERATOR')} ${getRequiredAsterisk('is_dray')}`, info: t('DRAY_OPERATOR'), onChange: (value) => this.handleFieldChange('is_dray', value), value: is_dray }),
                    React.createElement(CargomaticInput, { id: "test", type: "checkbox", error: errors.test, label: `${t('TEST_USER')} ${getRequiredAsterisk('test')}`, info: t('TEST_ACCOUNT'), onChange: (value) => this.handleFieldChange('test', value), value: test }),
                    React.createElement(CargomaticInput, { id: "lease_on", type: "checkbox", error: errors.lease_on, label: `${t('LEASE_ON')} ${getRequiredAsterisk('lease_on')}`, info: t('LEASE_ON_INFO'), onChange: (value) => this.handleFieldChange('lease_on', value), value: lease_on })),
                React.createElement("div", { className: "grid sm:grid-cols-2 sm:gap-4 mt-4" },
                    React.createElement(CargomaticSelect, { selected: group_like_payout_items ? 'Yes' : 'No', items: [{ slug: t('YES') }, { slug: t('NO') }], info: t('GROUP_PAY_ITEM_TIP'), label: t('GROUP_PAY_ITEMS'), textKey: "slug", valueKey: "slug", onSelect: (item) => {
                            const value = item.slug === 'Yes';
                            this.handleFieldChange('group_like_payout_items', value);
                        } }),
                    React.createElement(CargomaticSelect, { selected: subsidiary, items: CARRIER_SUBSIDIARY_OPTIONS, info: t('SUBSIDIARY_ITEM_TIP'), label: t('SUBSIDIARY'), textKey: "localizationSlug", valueKey: "value", onSelect: (item) => {
                            var _a;
                            this.handleFieldChange('subsidiary', (_a = item.value) !== null && _a !== void 0 ? _a : null);
                        } }),
                    React.createElement(CargomaticSelect, { className: "sm:col-start-2", selected: driver_categorization, items: DRIVER_CATEGORIZATION_OPTIONS, info: React.createElement("div", { className: "whitespace-pre-wrap" }, t('DRIVER_CATEGORIZATION_ITEM_TIP')), label: t('DRIVER_CATEGORIZATION'), disabled: !subsidiary, error: errors.driver_categorization, textKey: "localizationSlug", valueKey: "value", onSelect: (item) => {
                            var _a;
                            this.handleFieldChange('driver_categorization', (_a = item.value) !== null && _a !== void 0 ? _a : null);
                        } })))),
            React.createElement("div", { className: "my-2 form-actions" },
                React.createElement("button", { className: "button button-green", onClick: this.onSave, disabled: this.errorsExist() }, titleize(t('SAVE'))))));
    }
}
CarrierForm.propTypes = {
    onSave: PropTypes.func,
    details: PropTypes.object,
};
CarrierForm.defaultProps = {
    onSave: null,
    details: {},
};
export default withTranslation()(CarrierForm);
